'use client';

import React from 'react';
import { RenderStatus } from '@/shared/constants/status';
import { Progress } from '@/shared/ui/shadcn/progress';
import { cn } from '@/shared/lib/cn';

interface RenderProgressBarProps {
  progress?: number; // Progress from store (0-100)
  status: (typeof RenderStatus)[keyof typeof RenderStatus];
  className?: string;
  progressClassName?: string;
  isStalling?: boolean;
}

export function RenderProgressBar({
  progress = 0,
  status,
  className = '',
  progressClassName = '',
  isStalling,
}: RenderProgressBarProps) {
  // Use progress from props or determine based on status
  const displayProgress =
    status === RenderStatus.COMPLETED
      ? 100
      : status === RenderStatus.FAILED
        ? 0
        : progress;

  if (status === RenderStatus.PENDING) {
    return null; // Don't show progress bar for pending renders
  }

  return (
    <div className={cn('w-full', className)}>
      <Progress
        value={displayProgress}
        className={cn('h-1.5', progressClassName)}
        isStalling={isStalling}
      />
    </div>
  );
}
